export default __webpack_public_path__ + "static/media/new-loads.78d61063.svg";